import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { APICall } from "../../../Helpers/API/APICalls";
import { enagagementTypeOptions } from "../../../Common/CommonJson";
import { Decrypt } from "../../../Helpers/Cryptography/AES";
import CryptoJS from "crypto-js";
import { ApplicationContext } from "../../../Routes/Routes";
import moment from "moment";
import {
  GetDropDownList,
  insertUpdateMilestoneDataUrl,
  getMilestoneDataByIdUrl,
  CheckIfMilestoneExists,
  getCustomers,
  getCustomersformilestone,
  getPOData,
  getEngagementdd,
  getCurreny,
  getCustomerDataByEngagement,
  getEngagementMilestoneValue,
} from "../../../Helpers/API/APIEndPoints";
import "./MilestoneMaster.css";
import { getContext } from "../../../Helpers/Context/Context";
import Heading from "../../../Components/Heading/Heading";
import uuid from "react-uuid";
import { LoaderContext } from "../../../Helpers/Context/Context"; // added by mahesh
import { Label } from "@mui/icons-material";

const MilestoneMasterEdit = () => {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [milestone, setMilestone] = useState("");
  const [remark, SetRemark] = useState("");
  const [amount, setAmount] = useState("");
  const [engagement, setEngagement] = useState(null);
  const [plannedDate, setPlannedDate] = useState<Date | null>(null);
  const [revisedDate, setRevisedDate] = useState<Date | null>(null);
  const [completedDate, setCompletedDate] = useState<Date | null>(null);
  const [invoicedDate, setInvoicedDate] = useState<Date | null>(null);
  const [engagementDropdown, setEngagementDropdown] = useState([]);
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [createdDate, setCreatedDate] = useState<any>(null);
  const [plannedManDays, setPlannedManDays] = useState(0);
  const [actualManDays, setActualManDays] = useState(0);
  const [balanceManDays, setBalanceManDays] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [typeofEngagement, setTypeofEngagement] = useState<any>("");
  const [enagagementTypeOptionsArr, setEnagagementTypeOptionsArr] = useState(
    enagagementTypeOptions.sort((a, b) =>
      a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase())
    )
  );
  //sangam 28-may-24
  // add Customer dropdown
  const [customerOptionArr, setCustomerOptions] = useState<any>([]);
  const [customerDisable, setCustomerDisable] = useState(false);
  const [customerValue, setCustomerValue] = useState(null);
  const [PoStatus, setPoStatus] = useState(null);
  const [PoValue, setPOValue] = useState(null);
  const [POCurrency, setPoCurrency] = useState<any>([]);
  const [ConvertRateDisable, setConvertRateDisable] = useState(false);
  const [convertionRate, setConvertionRate] = useState(null);
  const [milestoneAmount, setMileStoneAmount] = useState(null);
  const [milestoneDisable, setMileStoneDisable] = useState(true);
  const [InrAmount, setInrAmount] = useState(null);
  const [invoceDateDisable, setInvoiceDateDisable] = useState(false);
  const [PoCurrencyId, setPoCurrencyId] = useState(null);
  const [referNumber, setRefNumber] = useState(null);
  const [ReferenceNumisDisable, setRefNumberDisable] = useState(true);
  const [POcurrencyDisable, setCurrencyDisable] = useState(true);
  const [currency, setCurrency] = useState(null);
  const [POValueDisable, setPOValueDisable] = useState(false);
  const [POStatusDisable, setPOStatusDisable] = useState(true);
  const [InvoiceNumisDisable, setInvoiceNumberDisable] = useState(true);
  const [invoicenumber, setInvoiceNumber] = useState("");
  const [invoiceDesc, setinvoiceDesc] = useState("");
  const [milestoneTotalAmt, setMilestoneTotalAmt] = useState(0);

  //

  const [engagementDisable, setEngagementDisable] = useState(false);
  const [formErrors, setFormErrors] = useState<any>({});
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext); //added by mahesh

  let formErrorObj = {};

  useEffect(() => {
    LoadCustomers();
    onLoadAPI();
    onLoadFunCall();
    getCurrency();
  }, []);

  useEffect(() => {
    setBalanceManDays(+plannedManDays - +actualManDays);
  }, [actualManDays, plannedManDays]);

  //sangam 28-may-204
  useEffect(() => {
    capacityEngagementApiCall();
  }, [typeofEngagement, customerValue]);

  useEffect(() => {
    setPoStatus("");
    setPOValue(null);
    setCurrency(null);
    //setPoCurrency([]);
    // setPoCurrencyId(null);
    setConvertionRate(null);
    setConvertRateDisable(false);
    // setInrAmount(null);
    // setMileStoneAmount(null);
    setMileStoneDisable(false);
    FetchPOData();
    GetEngagementTotalMileStone();
  }, [engagement]);

  // useEffect(()=>{
  //   if(PoValue != null)
  //   checkValidations();
  // },[PoStatus,PoValue])
  // useEffect(()=>{
  //   LoadCustomers();
  // },[typeofEngagement])

  useEffect(() => {
    handleCalculation();
  }, [milestoneAmount, convertionRate]);

  const handleCalculation = async () => {
    const amount = parseFloat(milestoneAmount);
    const rate = parseFloat(convertionRate);

    if (!isNaN(amount) && !isNaN(rate)) {
      setInrAmount(amount * rate);
    } else {
      setInrAmount("");
    }
  };

  //sangam
  const getCurrency = async () => {
    const obj = {};

    const { data } = await APICall(getCurreny, "POST", obj);

    if (data != undefined || data != null) {
      let currencyArray = [];
      await data.map((currency: any) => {
        let tempObj = {
          value: currency.id,
          label: currency.currency,
        };
        currencyArray.push(tempObj);
      });
      setPoCurrency(currencyArray);
    }
  };

  const LoadCustomers = async () => {
    const { data } = await APICall(getCustomersformilestone, "GET");

    if (data != undefined || data != null) {
      let CustomerArray = [];
      await data.map((customer) => {
        let tempObj = {
          label: customer.remark,
          value: customer.id,
        };
        CustomerArray.push(tempObj);
      });

      var tempArray = [...CustomerArray];
      setCustomerOptions(tempArray);
    }
  };

  const FetchPOData = async () => {
    let reqObj = {
      EngagementId: engagement && engagement.engagementId,
    };

    const { data } = await APICall(getPOData, "POST", reqObj);

    if (data != null && data.length > 0) {
      const poData = data[0];

      // setPoStatus(poData.poStatus !== 'null' ? poData.poStatus : '');
      // await setFormErrors({
      //   ...formErrors,
      //   ["poStatus_isEmpty"]: "",
      // });
      await selectOnChange(poData.poStatus, "PoStatus");
      // setInvoiceDateDisable(poData.poStatus === "Received"?false: true)
      setInvoicedDate(null);
      setRefNumber("");
      setInvoiceNumber("");

      // if(state == null){

      if (poData.poCurrency != null) {
        //setCurrency({value:poData.poCurrencyId,label:poData.poCurrency});

        selectOnChange(
          { value: poData.poCurrencyId, label: poData.poCurrency },
          "PoCurrency"
        );
        setCurrencyDisable(true);

        setMileStoneDisable(false);
        if (poData.poCurrency === "INR") {
          setConvertRateDisable(true);
          setConvertionRate(1);
        } else {
          setConvertRateDisable(false);
          setConvertionRate("");
        }
      } else {
        // setPoCurrency();

        setCurrencyDisable(false);
        setConvertRateDisable(false);
        setConvertionRate("");
        //setMileStoneAmount('');
        setMileStoneDisable(false);
      }

      //   }
      if (poData.poValue != null) {
        setPOValue(poData.poValue);
        await selectOnChange(poData.poValue, "PoValue");
        // await setFormErrors({
        //   ...formErrors,
        //   ["poValue_isEmpty"]: "",
        // });
      } else {
        setPOValue("0");
        setPOValueDisable(false);
      }
    }
  };

  const GetEngagementTotalMileStone = async () => {
    let postObj = {
      Engagementid: engagement && engagement.engagementId,
    }

    const { data } = await APICall(getEngagementMilestoneValue, "POST", postObj);

    if ((data != null || data != undefined) && data.length > 0) {
      //console.log("data1  ===>", data[0].totalMilestoneAmt);
      setMilestoneTotalAmt(data[0].totalMilestoneAmt);
    }
  }

  //
  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName == "PoValue") {
      await setPOValue(event);

      await setFormErrors({
        ...formErrors,
        ["poValue_isEmpty"]: "",
      });
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["poValue_isEmpty"]: "Select PoValue",
        });
      }
    }

    if (apiFieldName == "PoStatus") {
      await setPoStatus(event);

      await setFormErrors({
        ...formErrors,
        ["poStatus_isEmpty"]: "",
      });
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["poStatus_isEmpty"]: "Select PoStatus",
        });
      }
    }

    if (apiFieldName == "customerVal") {
      // setEngagement({});
      setEngagement("");
      // setPlannedDate(null);
      // setRevisedDate(null);
      // setCompletedDate(null);
      // setInvoicedDate(null);
      // setRefNumber(null);
      // setInvoiceNumber(null);
      await setCustomerValue(event);
      await setFormErrors({
        ...formErrors,
        ["customer_isEmpty"]: "",
      });
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["customer_isEmpty"]: "Select Customer",
        });
      }
    }
    if (apiFieldName == "engagement") {
      // setPlannedDate(null);
      // setRevisedDate(null);
      // setCompletedDate(null);
      // setInvoicedDate(null);
      // setRefNumber(null);
      // setInvoiceNumber(null);
      await setFormErrors({
        ...formErrors,
        ["engagement_isEmpty"]: "",
      });

      await setEngagement(event);
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["engagement_isEmpty"]: "Select Engagement",
        });
      }
    }
    if (apiFieldName == "PoCurrency") {
      await setCurrency(event);
      if (event.value === 1) {
        setConvertionRate(1);
        setConvertRateDisable(true);
      } else {
        setConvertionRate("");
        setConvertRateDisable(false);
      }

      await setFormErrors({
        ...formErrors,
        ["currency_isEmpty"]: "",
      });
      if (event == undefined || event == null || event == "") {
        await setFormErrors({
          ...formErrors,
          ["currency_isEmpty"]: "Select Currency",
        });
      }
    }

    if (apiFieldName === "typeofEngagement") {
      setEngagement("");
      // setPlannedDate(null);
      // setRevisedDate(null);
      // setCompletedDate(null);
      // setInvoicedDate(null);
      // setRefNumber(null);
      // setInvoiceNumber(null);
      setTypeofEngagement(event);
      if (event && Object.keys(event).length > 0) {
        await setFormErrors({
          ...formErrors,
          ["typeofEngagement_isEmpty"]: "",
        });
        // await capacityEngagementApiCall(event.value);
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["typeofEngagement_isEmpty"]: "Engagement type can not be empty",
        }));
        formErrorObj["typeofEngagement_isEmpty"] =
          "Engagement type can not be empty";
      }
    }
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName == "PoStatus") {
      let remark = event.target.value;
      await setPoStatus(remark);
      var test = /^[a-zA-Z\s]+$/.test(remark);

      await setFormErrors({
        ...formErrors,
        ["poStatus_isEmpty"]: "",
      });
      // if (remark == undefined || remark == null || remark == "") {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["Remark_isEmpty"]: "Remark cannot be empty",
      //   });
      // }
    }

    if (apiFieldName == "PoValue") {
      let povalue = event.target.value;
      await setPOValue(povalue);

      var test = /^\d*\.?\d*$/.test(povalue);
      if (test) {
        await setFormErrors({
          ...formErrors,
          ["poValue_isEmpty"]: "",
        });
        if (povalue == undefined || povalue == null || povalue == "") {
          await setFormErrors({
            ...formErrors,
            ["poValue_isEmpty"]: "PoValue cannot be empty",
          });
        }
      } else if (milestoneAmount > PoValue) {
        await setFormErrors({
          ...formErrors,
          ["poValue_isEmpty"]: "Milestone amount cannot be greater than PO Value"
        })
      }
      else {
        await setFormErrors({
          ...formErrors,
          ["poValue_isEmpty"]: "Invalid characters",
        });
      }

    }

    if (apiFieldName == "referenceNumber") {
      let numberValue = event.target.value;
      await setRefNumber(numberValue);
      // var test = /^\d*\.?\d*$/.test(numberValue);
      // if (test) {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["Refer_Number"]: "",
      //   });
      //   // if (amount == undefined || amount == null || amount == "") {
      //   //   await setFormErrors({
      //   //     ...formErrors,
      //   //     ["ConvertionRate_isEmpty"]: "Convertion rate cannot be empty",
      //   //   });
      //   // }
      // } else {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["Refer_Number"]: "Invalid characters",
      //   });
      // }
    }

    if (apiFieldName == "invoiceNumber") {
      let numberValue = event.target.value;
      await setInvoiceNumber(numberValue);
      // var test = /^\d*\.?\d*$/.test(numberValue);

      await setFormErrors({
        ...formErrors,
        ["Invoic_Number"]: "",
      });
      // if (amount == undefined || amount == null || amount == "") {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["ConvertionRate_isEmpty"]: "Convertion rate cannot be empty",
      //   });
      // }

      if (
        numberValue == undefined ||
        numberValue == null ||
        numberValue == ""
      ) {
        await setFormErrors({
          ...formErrors,
          ["Invoic_Number"]: "Invoice number cannot be empty",
        });
      }
    }

    if (apiFieldName == "convertionRate") {
      let amount = event.target.value;
      await setConvertionRate(amount);
      var test = /^\d*\.?\d*$/.test(amount);
      if (test) {
        await setFormErrors({
          ...formErrors,
          ["ConvertionRate_isEmpty"]: "",
        });
        if (amount == undefined || amount == null || amount == "") {
          await setFormErrors({
            ...formErrors,
            ["ConvertionRate_isEmpty"]: "Convertion rate cannot be empty",
          });
        }
      } else {
        await setFormErrors({
          ...formErrors,
          ["ConvertionRate_isEmpty"]: "Invalid characters",
        });
      }
    }

    if (apiFieldName == "milestoneAmount") {
      let amount = event.target.value;
      await setMileStoneAmount(amount);
      var test = /^\d*\.?\d*$/.test(amount);
      if (test) {
        await setFormErrors({
          ...formErrors,
          ["MileStoneamount_isEmpty"]: "",
        });
        if (amount == undefined || amount == null || amount == "") {
          await setFormErrors({
            ...formErrors,
            ["MileStoneamount_isEmpty"]: "MileStone amount cannot be empty",
          });
        }
      } else {
        await setFormErrors({
          ...formErrors,
          ["MileStoneamount_isEmpty"]: "Invalid characters",
        });
      }
    }

    if (apiFieldName == "milestone") {
      let milestone = event.target.value;
      await setMilestone(milestone);
      var test = /^[a-zA-Z\s]+$/.test(milestone);

      await setFormErrors({
        ...formErrors,
        ["Milestone_isEmpty"]: "",
        ["Milestone_exists"]: "",
      });
      if (milestone == undefined || milestone == null || milestone == "") {
        await setFormErrors({
          ...formErrors,
          ["Milestone_isEmpty"]: "Milestone cannot be empty",
        });
      }
    }

    if (apiFieldName == "Amount") {
      let amount = event.target.value;
      await setAmount(amount);
      var test = /^\d*\.?\d*$/.test(amount);
      if (test) {
        await setFormErrors({
          ...formErrors,
          ["Amount_isEmpty"]: "",
        });
        if (amount == undefined || amount == null || amount == "") {
          await setFormErrors({
            ...formErrors,
            ["Amount_isEmpty"]: "Amount cannot be empty",
          });
        }
      } else {
        await setFormErrors({
          ...formErrors,
          ["Amount_isEmpty"]: "Invalid characters",
        });
      }
    }

    if (apiFieldName == "plannedDate") {
      let plannedDate = event;
      await setPlannedDate(plannedDate);

      //Changes Made By Sai Date 15-09-2022
      await setRevisedDate(plannedDate);
      //
      await setFormErrors({
        ...formErrors,
        ["plannedDate_isEmpty"]: "",
        ["revisedDate_isEmpty"]: "",
      });
      if (
        plannedDate == undefined ||
        plannedDate == null ||
        plannedDate == ""
      ) {
        await setFormErrors({
          ...formErrors,
          ["plannedDate_isEmpty"]: "Planned Date cannot be empty",
          ["revisedDate_isEmpty"]: "Revised Date cannot be empty",
        });
      }
    }

    if (apiFieldName == "revisedDate") {
      let revisedDate = event;
      await setRevisedDate(revisedDate);
      await setFormErrors({
        ...formErrors,
        ["revisedDate_isEmpty"]: "",
      });
      if (
        revisedDate == undefined ||
        revisedDate == null ||
        revisedDate == ""
      ) {
        await setFormErrors({
          ...formErrors,
          ["revisedDate_isEmpty"]: "Revised Date cannot be empty",
        });
      }
    }

    if (apiFieldName == "completedDate") {
      let completedDate = event;
      await setCompletedDate(completedDate);
      await setFormErrors({
        ...formErrors,
        ["completedDate_isEmpty"]: "",
      });
      // if (
      //   completedDate == undefined ||
      //   completedDate == null ||
      //   completedDate == ""
      // ) {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["completedDate_isEmpty"]: "Completed Date cannot be empty",
      //   });
      // }
    }

    if (apiFieldName == "invoicedDate") {
      let invoicedDate = event;
      await setInvoicedDate(invoicedDate);

      await setFormErrors({
        ...formErrors,
        ["invoicedDate_isEmpty"]: "",
        ["invoiceDate_Validation"]: "",
      });
      // if (
      //   invoicedDate == undefined ||
      //   invoicedDate == null ||
      //   invoicedDate == ""
      // ) {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["invoicedDate_isEmpty"]: "Invoiced Date cannot be empty",
      //   });
      // }
    }
    if (apiFieldName == "Remark") {
      let remark = event.target.value;
      await SetRemark(remark);
      var test = /^[a-zA-Z\s]+$/.test(remark);

      await setFormErrors({
        ...formErrors,
        ["Milestone_isEmpty"]: "",
      });
      // if (remark == undefined || remark == null || remark == "") {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["Remark_isEmpty"]: "Remark cannot be empty",
      //   });
      // }
    }

    if (apiFieldName == "Invoice") {
      let invoiceDescp = event.target.value;
      await setinvoiceDesc(invoiceDescp);
      await setFormErrors({
        ...formErrors,
        ["Invoive_isEmpty"]: "",
      })
      // if(invoiceDesc == undefined || invoiceDesc == null || invoiceDesc == "")
      // {
      //   await setFormErrors({
      //     ...formErrors,
      //     ["Invoive_isEmpty"] : "Invoice cannot be empty",
      //   });
      // }
    }
  };
  const capacityEngagementApiCall = async () => {
    //setEngagement({})
    let postObject = {
      searchValue: typeofEngagement && typeofEngagement.value,
      CustomerValue: customerValue && customerValue.value,
    };
    const { data } = await APICall(getEngagementdd, "POST", postObject);

    if (data) {
      let engagementArray = [];
      if (typeofEngagement.value > 0) {
        await data.map((engagement: any) => {
          let tempObj = {
            phasevalue: null,
            label: `${engagement.engagement}`,
            value: uuid(),
            engagementId: engagement.id,
          };
          engagementArray.push(tempObj);
        });

        engagementArray.sort((a, b) => a.label.localeCompare(b.label));
        setEngagementOptions(engagementArray);
      }
      // else {
      //   engagementArray = [];
      //   await data.map((engagement) => {
      //     let tempObj;
      //     if (engagement.phase != null) {
      //       tempObj = {
      //         phasevalue: engagement.phaseId,
      //         label: `${engagement.engagement}-${engagement.phase}`,
      //         value: uuid(),
      //         engagementId: engagement.engagementId,
      //         // empId: engagement.employeeId,
      //         // engagementType: engagement.engagementType,
      //       };
      //     } else if (engagement.application != null) {
      //       tempObj = {
      //         applicationValue: engagement.applicationId,
      //         label: ` ${engagement.engagement}-${engagement.application}`,
      //         value: uuid(),
      //         engagementId: engagement.engagementId,
      //         // empId: engagement.employeeId,
      //         // engagementType: engagement.engagementType,
      //       };
      //     } else {
      //       tempObj = {
      //         phasevalue: engagement.phaseId,
      //         label: `${engagement.engagement}`,
      //         value: uuid(),
      //         engagementId: engagement.engagementId,
      //         // empId: engagement.employeeId,
      //         // engagementType: engagement.engagementType,
      //       };
      //     }
      //     engagementArray.push(tempObj);
      //   });
      //   setEngagementOptions(engagementArray);
      // }
    }
  };

  const getEngagementTypeFuncCall = () => {
    enagagementTypeOptions.map(async (ele: any) => {
      //setTypeofEngagement(ele);
      //await capacityEngagementApiCall(ele.value);
      // await engagementLeadsManagersApiCall()
    });
    setEnagagementTypeOptionsArr(enagagementTypeOptions);
  };

  const onLoadFunCall = async () => {
    //await getEngagementTypeFuncCall();
    // await capacityEngagementApiCall()
  };

  const checkValidations = async () => {
    var objError = {};

    if (engagement != null) {
      const data1 = await APICall(CheckIfMilestoneExists, "POST", {
        milestones: milestone,
        engagementId: engagement.engagementId,
      });
      if (data1 != undefined || data1 != null) {
        if (data1.data === true && state == null) {
          objError["Milestone_exists"] =
            "Milestone already exist for the particular engagement";
        }
      }
    }

    if (milestone == undefined || milestone == null || milestone == "") {
      objError["Milestone_isEmpty"] = "Milestone cannot be empty";
    }
    // if (remark == undefined || remark == null || remark == "") {
    //   objError["Remark_isEmpty"] = "Remark cannot be empty";
    // }

    if (
      customerValue == undefined ||
      customerValue == null ||
      customerValue == ""
    ) {
      objError["customer_isEmpty"] = "Customer cannot be empty";
    }

    if (
      milestoneAmount == undefined ||
      milestoneAmount == null ||
      milestoneAmount == ""
    ) {
      objError["MileStoneamount_isEmpty"] = "MileStone amount cannot be empty";
    }

    if (PoValue == undefined || PoValue == null || PoValue == "") {
      objError["poValue_isEmpty"] = "PoValue cannot be empty";
    }

    if (completedDate && (completedDate != null || completedDate != undefined) && PoStatus !== "Not Applicable") {
      if (milestoneTotalAmt > PoValue && milestoneAmount > PoValue) {
        //console.log("inside if")
        objError["poValue_validationFormilestone"] = `PO Value is less than milestone value. Total MileStone value is ${milestoneTotalAmt}`;
      }
    }

    if (
      (PoStatus == undefined || PoStatus == null || PoStatus == "") &&
      !POStatusDisable
    ) {
      objError["poStatus_isEmpty"] = "PoStatus cannot be empty";
    }

    if (
      (currency == undefined || currency == null || currency == "") &&
      !POcurrencyDisable
    ) {
      objError["currency_isEmpty"] = "PoCurrency cannot be empty";
    }

    if (
      convertionRate == undefined ||
      convertionRate == null ||
      convertionRate == ""
    ) {
      objError["ConvertionRate_isEmpty"] = "Convertion rate cannot be empty";
    }

    if (engagement == undefined || engagement == null || engagement == "") {
      objError["engagement_isEmpty"] = "Select Engagement";
    }

    if (plannedDate == undefined || plannedDate == null) {
      objError["plannedDate_isEmpty"] = "Planned Date cannot be empty";
    }

    if (revisedDate == undefined || revisedDate == null) {
      objError["revisedDate_isEmpty"] = "Revised Date cannot be empty";
    }

    if (
      typeofEngagement == undefined ||
      typeofEngagement == null ||
      typeofEngagement == ""
    ) {
      objError["typeofEngagement_isEmpty"] =
        "Type of engagement cannot be empty";
    }

    if (invoicedDate != null || invoicedDate != undefined) {
      if (
        invoicenumber == undefined ||
        invoicenumber == null ||
        invoicenumber == ""
      ) {
        objError["Invoic_Number"] = "Invoice number cannot be empty";
      }
    }

    const invalidStatuses = ["Pending", "Expired"];
    const isInvalidStatus =
      invalidStatuses.includes(PoStatus) && PoStatus !== "Not Applicable";

    if (isInvalidStatus && invoicedDate != null) {
      objError["invoiceDate_Validation"] =
        "Cannot pass invoice date if PO status is not received";
    }
    // if( (PoStatus != "Received") && (invoicedDate != undefined || invoicedDate != null) ){
    //       objError["invoiceDate_Validation"] =  "Cannot pass invoice date if PO status is not received";
    // } //commented by mahesh on 18-10-2024

    // if (
    //   completedDate == undefined ||
    //   completedDate == null ||
    //   completedDate == ""
    // ) {
    //   objError["completedDate_isEmpty"] = "Completed Date cannot be empty";
    // }

    // if (
    //   invoicedDate == undefined ||
    //   invoicedDate == null ||
    //   invoicedDate == ""
    // ) {
    //   objError["invoicedDate_isEmpty"] = "Invoiced Date cannot be empty";
    // }

    if (completedDate != undefined || completedDate != null) {
      if (invoiceDesc == undefined || invoiceDesc == null || invoiceDesc == "") {
        objError["Invoive_isEmpty"] = "Please fill the invoice description";
      }
    }

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );

      if (isEmpty) {
        let reqObject = {};
        if (state !== null) {
          reqObject = {
            Id: state,
            EditId: state,
            MileStones: milestone,
            EngagementId: engagement.engagementId,
            Amount: parseFloat(InrAmount),
            PlannedDate: moment(plannedDate).format(moment.HTML5_FMT.DATE),
            RevisedDate: moment(revisedDate).format(moment.HTML5_FMT.DATE),
            CompletedDate:
              completedDate !== null
                ? moment(completedDate).format(moment.HTML5_FMT.DATE)
                : null,
            InvoicedDate:
              invoicedDate !== null
                ? moment(invoicedDate).format(moment.HTML5_FMT.DATE)
                : null,
            MandaysBalance: balanceManDays,
            MandaysPlanned: plannedManDays,
            MandaysActual: actualManDays,
            Remark: remark,
            IsActive: isActive,
            ModifiedBy: context.EmployeeId,
            ModifiedDate: new Date(),
            //sangam 30 may 2024
            CustomerId: customerValue.value,
            PoCurrencyId: currency.value,
            PoCurrencyValue: currency.label,
            ConvertRate: parseFloat(convertionRate),
            MileStoneAmount: parseFloat(milestoneAmount),
            ReferenceNumber: referNumber !== null ? referNumber : null,
            InvoiceNumber:
              invoicedDate != null || invoicedDate != undefined
                ? invoicenumber
                : null,
            InvoiceDesc: completedDate != null || completedDate != undefined ? invoiceDesc : null,
          };
        } else {
          reqObject = {
            MileStones: milestone,
            EngagementId: engagement.engagementId,
            Amount: InrAmount !== null ? parseFloat(InrAmount) : null,
            PlannedDate: moment(plannedDate).format(moment.HTML5_FMT.DATE),
            RevisedDate: moment(revisedDate).format(moment.HTML5_FMT.DATE),
            CompletedDate:
              completedDate !== null
                ? moment(completedDate).format(moment.HTML5_FMT.DATE)
                : null,
            InvoicedDate:
              invoicedDate !== null
                ? moment(invoicedDate).format(moment.HTML5_FMT.DATE)
                : null,
            MandaysBalance: balanceManDays,
            MandaysPlanned: plannedManDays,
            MandaysActual: actualManDays,
            IsActive: true,
            createdDate: new Date(),
            Remark: remark,
            CreatedBy: context.EmployeeId,
            //sangam 30 may 2024
            CustomerId: customerValue.value,
            PoCurrencyId: currency.value, // idahr bhi
            PoCurrencyValue: currency.label,
            ConvertRate: parseFloat(convertionRate),
            MileStoneAmount: parseFloat(milestoneAmount),
            ReferenceNumber: referNumber !== null ? referNumber : null,
            InvoiceNumber:
              invoicedDate != null || invoicedDate != undefined
                ? invoicenumber
                : null,
            InvoiceDesc: completedDate != null || completedDate != undefined ? invoiceDesc : null,
          };
        }

        showLoader(); //added by mahesh

        const data = await APICall(
          insertUpdateMilestoneDataUrl,
          "POST",
          reqObject
        );

        if (data.status === 0) {
          navigate(-1);
        }
      }
      hideLoader(); //added by mahesh
    } else {
      setFormErrors({});
      setMilestone("");
      setAmount("");
      setEngagement("");
      setPlannedDate(null);
      setRevisedDate(null);
      setCompletedDate(null);
      setInvoicedDate(null);
      setCreatedDate(null);
      SetRemark("");
      setCustomerValue(null);
      setTypeofEngagement(null);
      setinvoiceDesc("");
    }
  };

  const CommonDropdownFunction = async (searchFor, searchValue) => {
    let postObject = {
      searchFor: searchFor,
      searchValue: searchValue,
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);

    return data;
  };

  const onLoadAPI = async () => {
    //Engagement Dropdown
    let EmployeeId = context.EmployeeId; //h
    var data = await CommonDropdownFunction("onlyEngagement", EmployeeId);

    if (data != undefined || data != null) {
      let engagementArray = [];
      await data.map((engagement) => {
        let tempObj = {
          label: `${engagement.engagement}`,
          engagementId: engagement.id,
          engagementTypeId: engagement.engagementType,
        };
        engagementArray.push(tempObj);
      });

      engagementArray.sort((a, b) => a.label.localeCompare(b.label));

      var tempArray = [...engagementArray];
      //setEngagementOptions(tempArray);
    }

    if (state != null || state != undefined) {
      await LoadCustomers();

      const data1 = await APICall(getMilestoneDataByIdUrl, "POST", {
        id: state,
      });

      if (
        data1 != undefined ||
        data1.data != undefined ||
        data1 != null ||
        data1.data != null
      ) {
        setInrAmount(data1?.data?.amount);

        let tempEng = { engagementTypeId: 0 };
        tempArray.map((engagement) => {
          if (engagement.engagementId == data1.data.engagementId) {
            setEngagement(engagement);
            tempEng = engagement;
          }
        });

        const eType = enagagementTypeOptions.find(
          (item) => item.value === tempEng.engagementTypeId
        );
        setTypeofEngagement(eType);

        const { data } = await APICall(getCustomersformilestone, "GET");

        let CustomerArray = [];
        if (data != undefined || data != null) {
          await data.map((customer) => {
            let tempObj = {
              label: customer.remark,
              value: customer.id,
            };
            CustomerArray.push(tempObj);
          });
        }

        const data2 = await APICall(getCustomerDataByEngagement, "POST", {
          Id: tempEng.engagementTypeId,
          EngagementId: data1.data.engagementId,
        });

        const customertemp = CustomerArray.find(
          (item) => item.value === data2.data[0].id
        );

        setCustomerValue(customertemp);
        setCustomerDisable(false); //prashant
        setCompletedDate(data1.data.completedDate);
        setMilestone(data1.data.mileStones);
        setPlannedDate(data1.data.plannedDate);
        setRevisedDate(data1.data.revisedDate);
        setCompletedDate(data1.data.completedDate);
        setInvoicedDate(data1.data.invoicedDate);
        setPlannedManDays(data1.data.mandaysPlanned);
        setActualManDays(data1.data.mandaysActual);
        setBalanceManDays(data1.data.mandaysBalance);
        setCreatedDate(data1.data.createdDate);
        setEngagementDisable(false); //prashant
        setIsActive(data1.data.isActive);
        setMileStoneAmount(data1.data.mileStoneAmount);
        SetRemark(data1.data.remark);

        setCurrency({
          value: data1.data.poCurrencyId,
          label: data1.data.poCurrencyValue,
        });
        setConvertionRate(data1.data.convertRate);
        setPOValueDisable(false);
        setCurrencyDisable(true);
        {
          data1.data.poCurrencyId === 1
            ? setConvertRateDisable(true)
            : setConvertRateDisable(false);
        }

        setInvoiceNumber(data1.data.invoiceNumber);
        setRefNumber(data1.data.referenceNumber);
        setinvoiceDesc(data1.data.invoiceDesc);

        //await FetchPOData();
        //setConvertionRate(data1.data.convertRate)
        //setTypeofEngagement(eType);
      }
    }
  };
  return (
    <>
      <Heading title={"Milestone"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Type of Engagement <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={enagagementTypeOptionsArr}
                placeholder="Select"
                isDisabled={engagementDisable}
                value={typeofEngagement}
                onChange={(event) => selectOnChange(event, "typeofEngagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <span style={{ color: "red" }}>
                {formErrors["typeofEngagement_isEmpty"]}
              </span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Customer <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={customerOptionArr}
                placeholder="Select"
                isDisabled={customerDisable}
                value={customerValue}
                onChange={(event) => selectOnChange(event, "customerVal")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <span style={{ color: "red" }}>
                {formErrors["customer_isEmpty"]}
              </span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement <sup>*</sup>
              </label>
              <SelectForm
                isDisabled={engagementDisable}
                options={EngagementOptions}
                placeholder="Select"
                value={engagement}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["engagement_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Milestone <sup>*</sup>
              </label>
              <InputForm
                isDisabled={engagementDisable}
                placeholder={"Milestone"}
                textArea={false}
                value={milestone}
                onChange={(e) => handleTextEvent(e, "milestone")}
              />

              <p style={{ color: "red" }}>
                {formErrors["Milestone_exists"]}

                {formErrors["Milestone_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO Status <sup>*</sup>
              </label>
              <InputForm
                isDisabled={POStatusDisable}
                placeholder={"PO Status"}
                textArea={false}
                value={PoStatus ? PoStatus : ""}
                className={"numRight"}
                onChange={(e) => handleTextEvent(e, "PoStatus")}
              />
              <p style={{ color: "red" }}>{formErrors["poStatus_isEmpty"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO Value <sup>*</sup>
              </label>
              <InputForm
                isDisabled={true}
                placeholder={"PO Value"}
                textArea={false}
                value={PoValue ? PoValue : ""}
                className={"numRight"}
                onChange={(e) => handleTextEvent(e, "PoValue")}
              />
              <p style={{ color: "red" }}>
                {formErrors["poValue_isEmpty"]}
                {formErrors["poValue_validationFormilestone"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO Currency <sup>*</sup>
              </label>
              <SelectForm
                isDisabled={POcurrencyDisable}
                options={POCurrency}
                placeholder="Select"
                value={currency}
                onChange={(event) => selectOnChange(event, "PoCurrency")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}> {formErrors["currency_isEmpty"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                INR Convert Rate <sup>*</sup>
              </label>
              <InputForm
                isDisabled={ConvertRateDisable}
                placeholder={"INR Convert Rate"}
                textArea={false}
                value={convertionRate ? convertionRate : ""}
                clasName={"numRight"}
                onChange={(e) => handleTextEvent(e, "convertionRate")}
              />

              <p style={{ color: "red" }}>
                {formErrors["ConvertionRate_isEmpty"]}
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Milestone Amount <sup>*</sup>
              </label>
              <InputForm
                isDisabled={milestoneDisable}
                placeholder={"Milestone Amount"}
                textArea={false}
                value={milestoneAmount || milestoneAmount == 0 ? milestoneAmount : ""}
                clasName={"numRight"}
                onChange={(e) => handleTextEvent(e, "milestoneAmount")}
              />

              <p style={{ color: "red" }}>
                {formErrors["MileStoneamount_isEmpty"]}
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>INR Amount</label>
              <InputForm
                isDisabled={true}
                placeholder={"INR Amount"}
                textArea={false}
                value={InrAmount ? InrAmount : ""}
                clasName={"numRight"}
                onChange={(e) => handleTextEvent(e, "InrAmount")}
              />
            </div>
          </div>

          {state != null && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="isActive">Is Active</label>
                <div>
                  <input
                    id="isActive"
                    type="checkbox"
                    onChange={(e) => setIsActive(e.target.checked)}
                    name="isActive"
                    checked={isActive}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label className="d-block">
                Planned Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Planned Date"
                  value={plannedDate}
                  onChange={(e) => handleTextEvent(e, "plannedDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport",
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["plannedDate_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label className="d-block">
                Revised Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Revised Date"
                  value={revisedDate}
                  onChange={(e) => handleTextEvent(e, "revisedDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport",
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["revisedDate_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Completed Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Completed Date"
                  value={completedDate}
                  onChange={(e) => handleTextEvent(e, "completedDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport",
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["completedDate_isEmpty"]}
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Invoice Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  disabled={invoceDateDisable}
                  label="Invoiced Date"
                  value={invoicedDate}
                  onChange={(e) => handleTextEvent(e, "invoicedDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport",
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>
                {formErrors["invoicedDate_isEmpty"]}
                {formErrors["invoiceDate_Validation"]}
              </p>
            </div>
          </div>

          {!invoceDateDisable &&
            (invoicedDate != undefined || invoicedDate != null) && (
              <>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Invoice Number <sup>*</sup>
                    </label>
                    <InputForm
                      isDisabled={
                        invoicedDate == undefined || invoicedDate == null
                          ? true
                          : false
                      }
                      placeholder={"InvoiceNumber"}
                      textArea={false}
                      value={invoicenumber ? invoicenumber : ""}
                      clasName={"numRight"}
                      onChange={(e) => handleTextEvent(e, "invoiceNumber")}
                    />

                    <p style={{ color: "red" }}>
                      {formErrors["Invoic_Number"]}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Reference Number</label>
                    <InputForm
                      isDisabled={
                        invoicedDate == undefined || invoicedDate == null
                          ? true
                          : false
                      }
                      placeholder={"ReferenceNumber"}
                      textArea={false}
                      value={referNumber ? referNumber : ""}
                      clasName={"numRight"}
                      onChange={(e) => handleTextEvent(e, "referenceNumber")}
                    />
                    {/* <p style={{ color: "red" }}>{formErrors["Refer_Number"]}</p> */}
                  </div>
                </div>
              </>
            )}

          {completedDate && (completedDate != undefined || completedDate != null) && (
            <>
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Invoice Description</label><sup>*</sup>
                  <InputForm
                    placeholder={""}
                    isDisabled={
                      completedDate == undefined || completedDate == null ? true : false
                    }
                    textArea={true}
                    value={invoiceDesc ? invoiceDesc : ""}
                    rows={3}
                    onChange={(e) => handleTextEvent(e, "Invoice")}
                  />
                </div>
                {<p style={{ color: "red" }}>{formErrors["Invoive_isEmpty"]}</p>}
              </div>
            </>
          )}

          <div className="col-lg-12">
            <div className="form-group">
              <label>Remark</label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={true}
                value={remark}
                rows={3}
                onChange={(e) => handleTextEvent(e, "Remark")}
              />
            </div>
            {/* <p style={{ color: "red" }}>{formErrors["Remark_isEmpty"]}</p> */}
          </div>



          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button onClick={() => navigate(-1)} className="btn btn-reset">
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-reset"
                  onClick={(e) => onClickFunction(e, "Reset")}
                >
                  Reset
                </button>
                <button
                  onClick={(e) => onClickFunction(e, "Submit")}
                  className="btn btn-submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MilestoneMasterEdit;
